const toNullableNumber = (value: number | string | null | undefined): number | null => {
	if (value === null || value === undefined || value === "") {
		return null
	}

	const parsedValue = Number(value)
	return Number.isFinite(parsedValue) ? parsedValue : null
}

export const hasApplicableClearance = (part: any, children?: any[] | null): boolean => {
	if (!part) {
		return false
	}

	if (part.isParent && children?.length) {
		return children.some((child) => Boolean(child?.clearanceItem))
	}

	return Boolean(part.clearanceItem)
}

export const shouldShowClearancePrice = (part: any, children?: any[] | null): boolean => {
	if (!part) {
		return false
	}

	const hasClearance = hasApplicableClearance(part, children)
	if (!hasClearance) {
		return false
	}

	const price = toNullableNumber(part.price)
	const netPrice = toNullableNumber(part.netPrice)

	return price !== null && netPrice !== null && price === netPrice
}

export const calculateListPriceFromDiscount = ({ clearanceItemDiscount, price }: any): any => {
	if (!clearanceItemDiscount || !price) return null

	const numericClearanceItemDiscount = Number(clearanceItemDiscount)
	const numericPrice = Number(price)

	if (
		Number.isNaN(numericClearanceItemDiscount) ||
		Number.isNaN(numericPrice) ||
		numericClearanceItemDiscount <= 0 ||
		numericClearanceItemDiscount >= 100
	) {
		return null
	}

	const listPrice = numericPrice / (1 - numericClearanceItemDiscount / 100)
	return Number(listPrice.toFixed(2))
}
